import { parseEntity } from '@/shared/converters/commonConverters';
import { DateTimeFormat, parseMoment } from '@/shared/converters/dateConverters';
import { durationAsMinutes } from '@/shared/utils/dateTime';
import BusinessHours from '../models/BusinessHours';

const SCHEMA = {
  daysOfWeek: 'dayOfWeek',
  start: (data: any) => parseMoment(data.startsAt, DateTimeFormat.PLANNER_TIME),
  end: (data: any) => parseMoment(data.stopsAt, DateTimeFormat.PLANNER_TIME),
  laborMinutes: (data: any) => durationAsMinutes(data.laborTime),
  plannedMinutes: (data: any) => durationAsMinutes(data.plannedTime),
};

export function parseBusinessHours(data: any): BusinessHours | null {
  return parseEntity(data, SCHEMA, BusinessHours);
}